import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import Footer from '../../components/common/footer';
import Header from '../../components/common/header';

const plusIcon = '/icons/plus.svg';
const linkIcon = '/icons/link.svg';
const manualIcon = '/icons/file-lines.svg';
const manualDoc = '/Manual-EstimaGas_Final.pdf';
const ods7 = '/images/ods-7.png';
const ods11 = '/images/ods-11.png';
const ods12 = '/images/ods-12.png';
const ods13 = '/images/ods-13.png';
const ods17 = '/images/ods-17.png';

function Home() {
  const [detalhes, setDetalhes] = useState(false);
  const navigate = useNavigate();

  const [isInverted, setIsInverted] = useState(false);

  const toggleInvert = () => {
    setIsInverted(!isInverted);
  };

  const handleManualClick = () => {
    window.open(manualDoc, '_blank');
  };

  const handleKeyPress = (event, action) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      action();
    }
  };
  
  return (
    <div 
      className={`flex flex-col min-h-screen fundo-morro ${isInverted ? 'inverted' : ''}`}
      role="application"
      aria-label="EstimaGas - Calculadora de Emissões de Gases"
    >
      <Header isInverted={isInverted} toggleInvert={toggleInvert} size={14}/>
      <main className='flex-grow p-20' role="main">
        <div className='container mx-auto'>          
          <div className='flex justify-center mt-4' role="navigation" aria-label="Menu principal">
            <div className='flex-1'></div>
            <div className='flex items-center space-x-2'>
              <button 
                className='bg-blue-500 text-stone-100 px-4 py-2 rounded font-bold' 
                onClick={() => setDetalhes(!detalhes)}
                aria-expanded={detalhes}
                aria-controls="sobre-estimagas"
                aria-label="Sobre o EstimaGas"
              >
                SOBRE O ESTIMAGAS
              </button>
              <img 
                className='cursor-pointer' 
                onClick={() => setDetalhes(!detalhes)}
                onKeyPress={(e) => handleKeyPress(e, () => setDetalhes(!detalhes))}
                src={plusIcon} 
                alt='Ícone de mais para expandir informações sobre o EstimaGas'
                role="button"
                tabIndex="0"
                aria-label="Expandir informações sobre o EstimaGas"
              />
            </div>
            <div className='flex-1'></div>
            <div className='flex items-center space-x-2'>
              <button 
                className='bg-amber-500 text-stone-100 px-4 py-2 rounded font-bold' 
                onClick={handleManualClick}
                aria-label="Abrir manual do EstimaGas em nova aba"
              >
                MANUAL
              </button>
              <img 
                className='cursor-pointer w-4' 
                onClick={handleManualClick}
                onKeyPress={(e) => handleKeyPress(e, handleManualClick)}
                src={manualIcon} 
                alt='Ícone de documento para acessar o manual do EstimaGas'
                role="button"
                tabIndex="0"
                aria-label="Abrir manual do EstimaGas"
              />
            </div>
            <div className='flex-1'></div>
            <div className='flex items-center space-x-2'>
              <Link 
                to='/estimagas' 
                className='bg-green-500 text-stone-100 px-4 py-2 rounded font-extrabold'
                aria-label="Iniciar o EstimaGas"
              >
                INICIAR
              </Link>
              <div 
                className='cursor-pointer' 
                onClick={() => navigate('/estimagas')}
                onKeyPress={(e) => handleKeyPress(e, () => navigate('/estimagas'))}
                role="button"
                tabIndex="0"
                aria-label="Iniciar o EstimaGas"
              >
                <img 
                  src={linkIcon} 
                  alt='Ícone de seta para iniciar o EstimaGas'
                  aria-hidden="true"
                />
              </div>
            </div>
            <div className='flex-1'></div>
          </div>

          {detalhes && (
            <div 
              id="sobre-estimagas"
              className='mt-4 space-y-4'
              role="region"
              aria-label="Informações sobre o EstimaGas"
            >
              <div className='bg-stone-100 p-6 rounded-lg border border-stone-400'>
                <p>O Estimagás é uma ferramenta projetada para calcular a produção de gás metano (CH4) e dióxido de carbono (CO2) resultante da disposição final de resíduos sólidos urbanos (RSU) em aterros sanitários no Rio Grande do Sul. As projeções geradas por essa ferramenta fornecem informações estratégicas essenciais para embasar a formulação de políticas públicas, orientar ações de governança e identificar oportunidades de investimento no setor, visando à mitigação dos Gases de Efeito Estufa (GEE).</p>
              </div>
              <div className='bg-stone-100 p-6 rounded-lg border border-stone-400'>
                <p>Cada local de destinação final de resíduos sólidos urbanos (RSU), seja município ou empresa, pode projetar e monitorar as emissões totais por tipo de gás. A ferramenta também permite avaliar a produção de biogás e a decomposição de carbono degradável, que resulta em metano, para cada categoria de RSU em aterros sanitários.</p>
              </div>
              <div className='bg-stone-100 p-6 rounded-lg border border-stone-400'>
                <p>O Governo do Estado do Rio Grande do Sul, por meio do Estimagás, busca oferecer suporte para que municípios e empresas compreendam melhor suas emissões e identifiquem oportunidades de mitigação dos GEE.</p>
              </div>
              <div className='bg-stone-100 p-6 rounded-lg border border-stone-400'>
                <h2 className="text-xl font-bold mb-4">Alinhamento aos ODS 2030 - Objetivos de Desenvolvimento Sustentável:</h2>
                <div className='flex flex-row align-middle items-center'>
                  <img className='w-16 pr-5' src={ods7} alt='Ícone do ODS 7 - Energia Limpa e Acessível' aria-hidden="true"/>
                  <p>ODS 7: Energia Limpa e acessível - Participação de energias renováveis na matriz energética global;</p>
                </div>
                <div className='flex flex-row align-middle items-center'>
                  <img className='w-16 pr-5' src={ods11} alt='Ícone do ODS 11 - Cidades e Comunidades Sustentáveis' aria-hidden="true"/>
                  <p>ODS 11: Cidades e Comunidades Sustentáveis - Até 2030, reduzir o impacto ambiental negativo per capita das cidades, inclusive prestando especial atenção à qualidade do ar, gestão de resíduos municipais e outros;</p>
                </div>
                <div className='flex flex-row align-middle items-center'>
                  <img className='w-16 pr-5' src={ods12} alt='Ícone do ODS 12 - Consumo e Produção Responsáveis' aria-hidden="true"/>
                  <p>ODS 12: Consumo e produção responsáveis - Até 2030, reduzir substancialmente a geração de resíduos por meio da prevenção, redução, reciclagem e reuso;</p>
                </div>
                <div className='flex flex-row align-middle items-center'>
                  <img className='w-16 pr-5' src={ods13} alt='Ícone do ODS 13 - Ação Contra a Mudança Global do Clima' aria-hidden="true"/>
                  <p>ODS 13: Ação contra a mudança global do Clima - Integrar medidas da mudança do clima nas políticas, estratégias e planejamentos nacionais;</p>
                </div>
                <div className='flex flex-row align-middle items-center'>
                  <img className='w-16 pr-5' src={ods17} alt='Ícone do ODS 17 - Parcerias e Meios de Implementação' aria-hidden="true"/>
                  <p>ODS 17: Parcerias e meios de implementação.</p>
                </div>
              </div>
              <div className='bg-stone-100 p-6 rounded-lg border border-stone-400'>
                <p>É importante salientar que o CH4 mitigado é tratado como geração. Em caso de emissão, seu lançamento esta sendo feito para a atmosfera contribuindo para a intensificação do efeito estufa antrópico observado as mudanças climáticas.</p>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Home;
